import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Switch } from 'components/Switch'
import { NumberInput } from 'components/NumberInput'
import { Select } from 'components/Select'
import { Button } from 'components/Button'
import { initializeApp } from 'firebase/app'
const {
  initializeAppCheck,
  ReCaptchaV3Provider
} = require('firebase/app-check')
import {
  getDatabase,
  ref,
  child,
  get,
  onValue,
  update,
  runTransaction
} from 'firebase/database'

const isMobile = window.innerWidth < 712
const getRisk = (perweek: number, heavy: boolean, gender: string) => {
  let risk = 'none'
  if (heavy) {
    risk = 'high'
  } else {
    if (
      (perweek > 0 && perweek <= 10 && gender === 'm') ||
      (perweek > 0 && perweek <= 5 && gender === 'f')
    ) {
      risk = 'low'
    }
    if (
      (perweek > 10 && perweek < 28 && gender === 'm') ||
      (perweek > 5 && perweek < 15 && gender === 'f')
    ) {
      risk = 'middle'
    }
    if (
      (perweek >= 28 && gender === 'm') ||
      (perweek >= 15 && gender === 'f')
    ) {
      risk = 'high'
    }
  }
  return risk
}
const calculateWeeklyGlasses = (drinks: number[]) => {
  return drinks.reduce((a, b) => a + b, 0)
}
const lSProp = 'alkohol_2022'

// FIREBASE CONNECTION
const firebaseConfig = {
  databaseURL: 'https://2022-alkoholrechner.europe-west1.firebasedatabase.app/',
  apiKey: 'AIzaSyDj4VVmQgxfq-59EBB4pZUVBZOOiE_FsPE',
  projectId: 'captchadatabases',
  storageBucket: 'captchadatabases.appspot.com',
  authDomain: 'captchadatabases.firebaseapp.com',
  messagingSenderId: '78621128630',
  appId: '1:78621128630:web:5b1182f6b86e20765df317'
}
const app = initializeApp(firebaseConfig)

const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('6LfTzxogAAAAAKMgEitsztk9cWSPNkj_j3RTbjQc'),
  isTokenAutoRefreshEnabled: true
})

const StyledCalculator = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  gap: 20px;

  h4 {
    max-width: ${isMobile ? '100%' : '70%'};
    margin-left: auto;
    margin-right: auto;
  }
  .info {
    font-family: var(--font-plex);
    font-size: 15px;
    line-height: 1.4em;
    max-width: ${isMobile ? '100%' : '70%'};
    margin-left: auto;
    margin-right: auto;
  }
`
const WrapperFull = styled.div`
  flex: 0 0 100%;
  min-width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  button {
    border-right: 2px solid var(--brandblue-bright-5);
  }
`
const IconWrapper = styled.div`
  flex: ${isMobile ? '0 0 100%' : '0 0 70%'};
  margin-bottom: 40px;
  &.fullinfo {
    font-family: var(--font-plex);
    margin-bottom: 0px;
    line-height: 1.4em;
    width: 100%;
    text-align: center;
    font-weight: 700;
  }
`
const DrinksWrapper = styled.div`
  min-width: 100%;
  margin-bottom: 40px;
`
const Disclaimer = styled.div`
  font-size: 12px;
  font-family: var(--font-plex);
  line-height: 1.5em;
  max-width: ${isMobile ? '100%' : '70%'};
`
const EarlyFeedback = styled.div`
  font-size: 15px;
  font-family: var(--font-plex);
  line-height: 1.5em;
  margin-top: 15px;
`
const InputLabel = styled.div`
  font-family: var(--font-plex);
  text-align: left;
  line-height: 1.4em;
  margin-bottom: 15px;
  font-size: 16px;
  flex: 0 0 100%;
  letter-spacing: 0.4px;
  justify-content: center;
  flex: 0 0 100%;
  &.error {
    color: #f00;
  }
  &.drinks {
    margin-bottom: 0;
  }
`
const InputSub = styled.div`
  font-family: var(--font-plex);
  text-align: left;
  font-size: 12px;
  line-height: 1.4em;
  margin-top: -5px;
  margin-bottom: 15px;
`

export const Calculator = ({
  getUserInputs,
  getDBData,
  TEXT
}: {
  getUserInputs: (e: UserInputTypes) => void
  getDBData: (e: DBDataType | undefined) => void
  TEXT: { [key: string]: string | string[] | string[][] | JSX.Element }
}) => {
  const [participated, setParticipated] = useState<boolean>(
    localStorage.getItem(lSProp) ? true : false
  )
  const local = localStorage.getItem(lSProp)
  const [inputs, setInputs] = useState<UserInputTypes>(
    local
      ? JSON.parse(local)
      : {
          gender: '_',
          drinks: [0, 0, 0],
          frequency: '-',
          heavyOnceAMonth: '_',
          age: '-'
        }
  )

  const [collectedData, setCollectedData] = useState<DBDataType>()

  const readDataFromDB = async () => {
    const dbRef = ref(getDatabase(app))
    const snap1 = await new Promise((resolve, reject) => {
      onValue(dbRef, snap => resolve(snap), { onlyOnce: true })
    })
    if (snap1.exists()) {
      let v = snap1.val()
      // console.log('m', v.risk.m.high - v.heavy.m)
      // console.log('f', v.risk.f.high - v.heavy.f)
      // console.log(
      //   Object.entries(v.gender.m)
      //     .filter(f => +f[0] > 5 && +f[0] <= 10)
      //     .reduce((a, b) => a + b[1], 0)
      // )
      // console.log(
      //   Object.entries(v.gender.m)
      //     .filter(f => +f[0] >= 28)
      //     .reduce((a, b) => a + b[1], 0)
      // )
      // console.log(
      //   Object.entries(v.gender.f)
      //     .filter(f => +f[0] > 5 && +f[0] <= 10)
      //     .reduce((a, b) => a + b[1], 0)
      // )

      setCollectedData(snap1.val())
    } else {
      console.log('No data in DB')
    }

    // get(child(dbRef, `/`))
    //   .then(snapshot => {
    //     if (snapshot.exists()) {
    //       setCollectedData(snapshot.val())
    //     } else {
    //       console.log('No data in DB')
    //     }
    //   })
    //   .catch(error => {
    //     console.error(error)
    //   })
  }
  const writeUserInputsTODatabase = async (
    perWeek: number,
    gender: string,
    frequency: string,
    heavy: boolean,
    drinks: number[],
    risk: string
  ) => {
    const dbref = ref(getDatabase())
    try {
      console.log('db transaction start')

      await runTransaction(dbref, a => {
        if (a) {
          // Update weekly drinks by gender
          if (a.gender && a.gender[gender]) {
            let genderdata = a.gender[gender]
            let val = 1
            if (genderdata[perWeek] || genderdata[perWeek] === 0)
              val = genderdata[perWeek] + 1

            update(dbref, {
              [`gender/${gender}/${perWeek}`]: val
            })
          }
          // Update drinking frequency by gender
          if (a.frequency && a.frequency[gender]) {
            let frequencydata = a.frequency[gender]
            let val = 1
            if (frequencydata[frequency] || frequencydata[frequency] === 0)
              val = frequencydata[frequency] + 1

            update(dbref, {
              [`frequency/${gender}/${frequency}`]: val
            })
          }
          // Update heavy drinking once a month
          if (a.heavy) {
            let heavydata = a.heavy
            let val = 1
            if (heavydata[gender] || heavydata[gender] === 0)
              val = heavydata[gender]
            if (heavy) val = val + 1
            update(dbref, {
              [`heavy/${gender}/`]: val
            })
          }

          // Update risk by gender
          if (a.risk && a.risk[gender]) {
            let riskdata = a.risk[gender]

            let val = 1
            if (riskdata[risk] || riskdata[risk] === 0) val = riskdata[risk] + 1

            update(dbref, {
              [`risk/${gender}/${risk}`]: val
            })
          }

          // Update drinks per type
          if (a.drinks && a.drinks[gender]) {
            let drinksdata = a.drinks[gender]
            let val_beer = 1
            let val_wine = 1
            let val_snaps = 1
            if (drinksdata.beer || drinksdata.beer === 0)
              val_beer = drinksdata.beer + drinks[0]
            if (drinksdata.wine || drinksdata.wine === 0)
              val_wine = drinksdata.wine + drinks[1]
            if (drinksdata.snaps || drinksdata.snaps === 0)
              val_snaps = drinksdata.snaps + drinks[2]

            update(dbref, {
              [`drinks/${gender}/beer`]: val_beer
            })
            update(dbref, {
              [`drinks/${gender}/wine`]: val_wine
            })
            update(dbref, {
              [`drinks/${gender}/snaps`]: val_snaps
            })
          }

          // readDataFromDB()
          console.log('db transaction finished')
          readDataFromDB()
        }

        return a
      })
    } catch (e) {
      console.warn('e', e)
    }
  }

  useEffect(() => {
    readDataFromDB()
  }, [])

  useEffect(() => {
    if (!collectedData) return
    getDBData(collectedData)
  }, [local, collectedData])

  useEffect(() => {
    if (!inputs.perweek) {
      inputs.perweek = inputs.drinks.reduce((a, b) => a + b, 0)
    }
    if (!inputs.risk) {
      inputs.risk = getRisk(
        inputs.perweek,
        inputs.heavyOnceAMonth === 'y',
        inputs.gender
      )
    }
    getUserInputs(inputs)
  }, [local, collectedData])

  // change user data
  const genderChange = (value: string | number) => {
    setInputs({ ...inputs, gender: value as string })
  }
  const heavyChange = (value: string | number) => {
    setInputs({ ...inputs, heavyOnceAMonth: value as string })
  }
  const drinksChange = (value: number[]) => {
    setInputs({ ...inputs, drinks: value })
  }
  const frequencyChange = (value: string) => {
    setInputs({ ...inputs, frequency: value })
  }
  const ageChange = (value: string) => {
    setInputs({ ...inputs, age: value })
  }
  const riskChange = (value: string) => {
    setInputs({ ...inputs, risk: value })
    // getRisk(perWeek, heavyOnceAMonth === 'y', gender)
  }

  const { gender, drinks, frequency, heavyOnceAMonth, age } = inputs
  const questions = TEXT.questions as string[][]
  const frequencyOptions = [
    { label: questions[1][2], id: 'lesthanone' },
    { label: questions[1][3], id: 'onetotwo' },
    { label: questions[1][4], id: 'threetosix' },
    { label: questions[1][5], id: 'daily' }
  ]
  const perWeek = calculateWeeklyGlasses(drinks)

  // "abstinent"-option only valid when no drinks
  if (perWeek === 0)
    frequencyOptions.unshift({ label: questions[1][1], id: 'abstinent' })

  return (
    <StyledCalculator className='Calculator'>
      <h4>{TEXT.title}</h4>
      <div className='info'>
        <p>{TEXT.lead} </p>
      </div>
      <DrinksWrapper>
        <DrinksInput
          current={drinks}
          change={drinksChange}
          disabled={participated}
          labels={TEXT.drinks as string[]}
        />
      </DrinksWrapper>
      <WrapperFull>
        <IconWrapper>
          <InputLabel>{questions[0][0]}</InputLabel>
          <Switch
            current={gender}
            change={genderChange}
            entries={[
              { label: questions[0][1], value: 'f' },
              { label: questions[0][2], value: 'm' }
            ]}
            disabled={participated}
          />{' '}
        </IconWrapper>
      </WrapperFull>
      <WrapperFull>
        <IconWrapper>
          <InputLabel>{questions[3][0]}</InputLabel>
          <Select
            noLabel
            text={TEXT.select}
            current={age}
            disabled={participated}
            entries={[
              { label: questions[3][1], id: 'age_15_24' },
              { label: questions[3][2], id: 'age_25_34' },
              { label: questions[3][3], id: 'age_35_44' },
              { label: questions[3][4], id: 'age_45_54' },
              { label: questions[3][5], id: 'age_55_64' },
              { label: questions[3][6], id: 'age_65_74' },
              { label: questions[3][7], id: 'age_75' }
            ]}
            change={ageChange}
          />
        </IconWrapper>
      </WrapperFull>
      <WrapperFull>
        <IconWrapper>
          <InputLabel>{questions[1][0]}</InputLabel>
          <Select
            text={TEXT.select}
            noLabel
            current={frequency}
            entries={frequencyOptions}
            change={frequencyChange}
            disabled={participated}
          />
        </IconWrapper>
      </WrapperFull>
      <WrapperFull>
        <IconWrapper>
          <InputLabel>{questions[2][0]}</InputLabel>
          <Switch
            current={heavyOnceAMonth}
            change={heavyChange}
            entries={[
              { label: questions[2][1], value: 'y' },
              { label: questions[2][2], value: 'n' }
            ]}
            disabled={participated}
          />
        </IconWrapper>
      </WrapperFull>{' '}
      {participated ||
        ((gender === '_' ||
          age === '-' ||
          frequency === '-' ||
          heavyOnceAMonth === '_' ||
          (perWeek > 0 && frequency === 'abstinent')) && (
          <IconWrapper className='fullinfo'>{TEXT.fillout}</IconWrapper>
        ))}
      <WrapperFull>
        <Button
          type='callToAction'
          disabled={
            participated ||
            gender === '_' ||
            age === '-' ||
            frequency === '-' ||
            heavyOnceAMonth === '_' ||
            (perWeek > 0 && frequency === 'abstinent')
          }
          onClick={() => {
            const perweek = calculateWeeklyGlasses(drinks)

            const risk = getRisk(perweek, heavyOnceAMonth === 'y', gender)
            riskChange(risk)

            // return user inputs to main state
            getUserInputs({ ...inputs, perweek })

            // toggle input elements to not changeable
            setParticipated(true)

            // Write user inputs into local storage
            localStorage.setItem(lSProp, JSON.stringify(inputs))

            // scroll to evaluation after finishing input
            let el = document.getElementById('evaluation')
            if (el) {
              el.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }

            // write user inputs to database
            if (collectedData) {
              writeUserInputsTODatabase(
                perweek,
                gender,
                frequency,
                heavyOnceAMonth === 'y',
                drinks,
                risk
              )
            }
          }}
        >
          {!participated
            ? (TEXT.buttons as string[])[0]
            : (TEXT.buttons as string[])[1]}
        </Button>
      </WrapperFull>
      <EarlyFeedback>{TEXT.earlyfeedback}</EarlyFeedback>
      <Disclaimer>{TEXT.disclaimer}</Disclaimer>
    </StyledCalculator>
  )
}

/*

3 Inputs for amount of drinks

*/
const StyledDrinksInput = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  gap: 15px;
  justify-content: center;

  .label {
    min-height: 3em;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;

    flex: 0 0 100%;
  }
`
const DrinkWrapper = styled.div`
  flex: 0 0 calc(33.33333% - 15px);
  text-align: center;

  img {
    max-width: 200px;
  }
`
const drinkIcons = ['beer.svg', 'wine.svg', 'snaps.svg']
const drinkSubs = ['3dl', '1dl', '3cl']
const DrinksInput = ({
  current,
  change,
  disabled,
  labels
}: {
  current: number[]
  change: (e: number[]) => void
  disabled: boolean
  labels: string[]
}) => {
  const [drinks, setDrinks] = useState(current)
  const handleChange = (id: number, value: number) => {
    let newDrinks = [...drinks]
    newDrinks[id] = +(value + ''.replace(/^0+/, ''))
    setDrinks(newDrinks)
  }
  useEffect(() => {
    change(drinks)
  }, [drinks])
  return (
    <StyledDrinksInput>
      {drinks.map((m, i) => {
        return (
          <DrinkWrapper key={'drinksinput' + i}>
            <img
              src={require('images/' + drinkIcons[i])}
              style={{ height: '100px' }}
            />
            <InputLabel
              style={{ textAlign: 'center' }}
              className='label drinks'
            >
              {labels[i]}
            </InputLabel>
            <InputSub style={{ textAlign: 'center' }}>{drinkSubs[i]}</InputSub>
            <NumberInput
              current={m}
              change={val => handleChange(i, val)}
              id={i}
              disabled={disabled}
            />
          </DrinkWrapper>
        )
      })}
    </StyledDrinksInput>
  )
}
